<template>
    <div>
        <mini-step class="f-topic-official-more-content"
            :info="OfficialBoardLabel.AnswerContent">
            <editor-component slot="editor"
                ref="officialReply"
                v-show="!isAuditPending
                    && !isClosed && canOperateOfficial"
                class="f-topic-official-more-editor"
                :editorid="'officialReplyEditor'"
                :existcontent="answerContent"
                :placeholder="answerPlaceHolder">
            </editor-component>
            <div slot="text"
                v-if="isAuditPending
                    || isClosed
                    || !canOperateOfficial"
                v-html="answerContent"
                class="f-topic-official-more-scroll">
            </div>
        </mini-step>

        <div class="f-topic-official-more-bottom"
            v-if="!isClosed && canOperateOfficial">
            <veui-button ui="primary"
                class="f-topic-official-more-bottom-btn"
                @click="saveOfficialReply"
                :disabled="isAuditPending">
                设置
            </veui-button>
        </div>
    </div>
</template>

<style lang="less">
    @import '../../../../assets/less/views/topic-content/official-process/official-process-board.less';
</style>

<script>
import {mapState, mapGetters} from 'vuex';
import MiniStep from './MiniStep.vue';
import Editor from '@/views/components/tinyEditor';
import {Button} from 'veui';
import {throttle} from '@/utils/debounceThrottle';
import toast from 'veui/managers/toast';
import {scrollToId} from '@/utils/decorate/scroll';

export default {
    components: {
        'mini-step': MiniStep,
        'editor-component': Editor,
        'veui-button': Button
    },
    computed: {
        ...mapState({
            OfficialBoardLabel: state => state.topicContent.OfficialBoardLabel,
            showTips: state => state.topicContent.showTips,
            answerContent: state => state.topicContent.topicData.ext.qaOfficialInfo.answerContent
        }),
        ...mapGetters([
            'isAuditPending',
            'isClosed',
            'canOperateOfficial',
            'answerPlaceHolder'
        ])
    },
    mounted() {
        this.resetAnswerReply();
    },
    methods: {
        getReply() {
            const content = this.$refs.officialReply.getContent();
            return content;
        },
        resetAnswerReply() {
            if (this.$refs.officialReply) {
                if (this.answerContent.length) {
                    this.$refs.officialReply.setContent(this.answerContent);
                }
                else {
                    this.$refs.officialReply.setPlaceholder(
                        this.$refs.officialReply,
                        this.answerPlaceHolder
                    );
                }
            }
        },
        // 提交回复
        saveOfficialReply: throttle(function () {
            let pureText = this.$refs.officialReply.getText();
            let content = this.$refs.officialReply.getContent();
            // 纯文本为空，但不拦住纯图片
            if (pureText.length === 0 && content.indexOf('img') === -1) {
                toast.info(this.showTips.missInfoParams);
                scrollToId('official-step-3');
                return;
            }
            // placeholder不计算
            if (content.indexOf('id="placeholder"') > -1) {
                toast.info(this.showTips.missInfoParams);
                scrollToId('official-step-3');
                return;
            }
            this.$store.dispatch('setOfficialReply', content)
                .then(() => scrollToId('official-step-3'));
        })
    }
};
</script>
